<template>
  <v-tabs icons-and-text>
    <v-tabs-slider color="accent"></v-tabs-slider>
    <router-view></router-view>
  </v-tabs>
</template>

<script>
import Shared from "@/mixins/Shared";

export default {
  name: "FormPayment",
  mixins: [Shared]
};
</script>

<style style lang="scss" scoped>
.router-link-active i {
  color: #ff0000 !important;
  background-color: #ff0000 !important;
}
.v-tabs__div {
  min-width: 100px;
}
</style>
